define(['jquery', 'jquery.transit', 'modernizr', 'container', 'jump'], function($, transit, modernizr, container, jumpFactory) {

    var hover = function(id) {

        const jump = jumpFactory.create();

        var publicVars = {
        };

        var privateVars = {
            name: 'back-top(' + id + ')',
            topStartHeight: 10,
            bottomHideHeight: 0,
            enabled: true
        };


        var privateMethods = {
            prepareObj: function(options) {
                publicVars = $.extend(true, publicVars, options);

                privateMethods.startup();
                privateMethods.bind();
            },
            startup: function() {
                privateMethods.calculateTopBottom();
            },

            bind: function() {
                container.msg(privateVars.name + ' - module started');

                $(window).scroll(function(event) {

                    var ticking = false;

                    //if (view.privateVars.canNavigateAction === 0) {

                    if (!ticking) {
                        window.requestAnimationFrame(function() {
                            privateMethods.handleCurrentScrollPosition(event);
                            ticking = false;
                        });
                    }
                    ticking = true;
                    //}
                });

                $(window).bind('mousewheel DOMMouseScroll', function(event) {

                    //if (view.privateVars.canNavigateAction === 0) {
                    privateMethods.handleMouseScroll(event);
                    //} else {
                    //    event.preventDefault();
                    //}
                });

                $(publicVars.cssId.backTopId).click(function() {
                    privateMethods.handleBackTopClick();
                });
            },

            calculateTopBottom: function () {
                privateVars.topStartHeight = 10;
                privateVars.bottomHideHeight = 0;

                if(publicVars.topHeightSpace && Array.isArray(publicVars.topHeightSpace)) {
                    publicVars.topHeightSpace.forEach((item) => {
                        privateVars.topStartHeight += parseInt($(item).outerHeight())
                    });
                }

                if(publicVars.bottomHeightSpace && Array.isArray(publicVars.topHeightSpace)) {
                    publicVars.bottomHeightSpace.forEach((item) => {
                        privateVars.bottomHideHeight += parseInt($(item).outerHeight())
                    });
                }
            },

            handleCurrentScrollPosition: function(event) {
                privateMethods.handleMouseScroll();
            },
            handleMouseScroll: function() {

                if(!privateVars.enabled) {
                    return;
                }

                var systemCurrentScroll = $(document).scrollTop();
                var systemWindowHeight = $(window).outerHeight();
                const bodyHeight = $('body').outerHeight();

                privateMethods.calculateTopBottom();

                if (systemCurrentScroll > privateVars.topStartHeight) {
                    $(publicVars.cssId.backTopId).fadeIn(300);
                } else {
                    $(publicVars.cssId.backTopId).fadeOut(100, function() {
                    });
                }

                if((bodyHeight - systemCurrentScroll - systemWindowHeight) <= (privateVars.bottomHideHeight)) {
                    $(publicVars.cssId.backTopId).addClass(publicVars.cssId.backTopPositionCls.substr(1));
                } else {
                    $(publicVars.cssId.backTopId).removeClass(publicVars.cssId.backTopPositionCls.substr(1));
                }
            },

            handleBackTopClick: function () {

                const systemCurrentScroll = $(document).scrollTop();

                jump.jumpTo('body', {
                    speed: parseInt(systemCurrentScroll / 5)
                });
            },

            disable: function () {
                $(publicVars.cssId.backTopId).css({ display: 'none'});
                privateVars.enabled = false;
            },

            enable: function () {
                privateVars.enabled = true;
                privateMethods.handleMouseScroll();
            }

        };


        var publicObj = {
            init: function(options) {
                privateMethods.prepareObj(options);
            },
            enable: function () {
                privateMethods.enable();
            },
            disable: function () {
                privateMethods.disable();
            }
        }

        return publicObj;
    };

    var factory = {
        objId: 0,
        /**
         * Get new number object
         * 
         * @returns preloader
         */
        create: function() {
            factory.objId++;

            var obj = hover(factory.objId);

            return obj;
        }
    };

    return {
        create: factory.create
    }

});
